import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import client from "../../../app/core/client-http/client";
import { PURGE } from "redux-persist";
import { endpoint } from "../../../utils/constants/endpoint";
import { toast } from "react-toastify";

const _initialState = {
  emailRecover: "",
  status: "idle",
  isLoading: false,
  roles: [],
};

export const doSendEmail = createAsyncThunk(
  "forgotPassword/recoverGenericPassword",
  async (email, thunkAPI) => {
    const response = await client.post(
      endpoint.ADMIN_ACCOUNT.GUEST_RECOVER.PASSWORD_GENERIC,
      {},
      { email: email }
    );
    if (response.ok) {
      if (response.data.Result === 1) {
        return thunkAPI.fulfillWithValue(response.data);
      } else if (response.data.Result === 6) {
        toast.error("email non valida");
      } else {
        toast.error(response.data.StringResult);
      }
    }
    return thunkAPI.rejectWithValue();
  }
);

// export const doSendEmailRecoverAdmin = createAsyncThunk(
//   "forgotPassword/recoverAdminPassword",
//   async (email, thunkAPI) => {
//     const response = await client.post(
//       endpoint.ADMIN_ACCOUNT.GUEST_RECOVER.PASSWORD,
//       {},
//       { email: email }
//     );
//     if (response.ok) {
//       return thunkAPI.fulfillWithValue(response.data);
//     } else {
//       return thunkAPI.rejectWithValue();
//     }
//   }
// );

// export const doSendEmailRecoverUser = createAsyncThunk(
//   "forgotPassword/recoverUserPassword",
//   async (email, thunkAPI) => {
//     const response = await client.post(
//       endpoint.USERS.GUEST_RECOVER_PASSWORD,
//       {},
//       { email: email }
//     );
//     if (response.ok) {
//       return thunkAPI.fulfillWithValue(response.data);
//     } else {
//       return thunkAPI.rejectWithValue();
//     }
//   }
// );

const forgotPasswordSlice = createSlice({
  name: "forgotPassword",
  initialState: _initialState,
  reducers: {
    setEmailRecover: (state, action) => {
      state.emailRecover = action.payload;
    },
    setIdle: (state, action) => {
      state.status = "idle";
    },
    resetState: (state, action) => {
      return _initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(doSendEmail.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(doSendEmail.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.Result === 1) {
          if (action.payload.Data.Result) {
            state.status = "done";
          } else {
            state.status = "pending";
            state.roles = action.payload.Data.EmailRoles;
          }
        } else {
          toast.error(action.payload.StringResult);
        }
      })
      .addCase(doSendEmail.rejected, (state, action) => {
        state.status = "idle";
        state.isLoading = false;
      })

      // .addCase(doSendEmailRecoverAdmin.pending, (state) => {
      //   state.isLoading = true;
      // })
      // .addCase(doSendEmailRecoverAdmin.fulfilled, (state, action) => {
      //   state.isLoading = false;
      //   state.status = "done";
      // })
      // .addCase(doSendEmailRecoverAdmin.rejected, (state, action) => {
      //   state.status = "idle";
      //   state.isLoading = false;
      // })
      // .addCase(doSendEmailRecoverUser.pending, (state) => {
      //   state.isLoading = true;
      // })
      // .addCase(doSendEmailRecoverUser.fulfilled, (state, action) => {
      //   state.isLoading = false;
      //   state.status = "done";
      // })
      // .addCase(doSendEmailRecoverUser.rejected, (state, action) => {
      //   state.isLoading = false;
      //   state.status = "idle";
      // })
      .addCase(PURGE, (state) => {
        state = _initialState;
        return state;
      });
  },
});

export const { name, reducer, actions } = forgotPasswordSlice;
